import { render } from "./tithing-message.vue?vue&type=template&id=442b9b82"
import script from "./tithing-message.vue?vue&type=script&lang=js"
export * from "./tithing-message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__